import * as React from 'react';
import S from './CtaLink.styles';
const CtaLink = ({ children, size = 'default', variant = 'default', ...otherProps }) => {
    return (React.createElement(S.Container, { ...otherProps, "data-size": size, "data-variant": variant }, children));
};
export default CtaLink;
